import React from 'react';
import { Spin } from 'antd';
import { useGlobalSpinnerContext } from 'app/providers/GlobalSpinner';
import styles from './GlobalSpinner.module.scss';

export const GlobalSpinner: React.FC = () => {
  const { isVisible, text } = useGlobalSpinnerContext();

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <Spin size="large" />
      {text && (
        <div className={styles.text}>
          {text}
        </div>
      )}
    </div>
  );
};
